import React from 'react';
import s from './StatGrid.module.css';

// A row of headline figures. Each stat is { value, label }, where label may be
// a fragment when it needs a second line.
export default function StatGrid({ stats, className }) {
  return (
    <div className={[s.grid, className].filter(Boolean).join(' ')}>
      {stats.map((stat, i) => (
        <div className={s.stat} key={stat.key || i}>
          <b className={s.value}>{stat.value}</b>
          <span className={s.label}>{stat.label}</span>
        </div>
      ))}
    </div>
  );
}
